import { Image as FoundationsImage } from 'foundations-components/transitional/components/Image';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/components/View';
import { AppleSignInDiv, ButtonText, ImageWrapper } from './AppleLoginButton.styles';
// @ts-expect-error not converted to TS
import Image from 'LoginUI/images/imageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppleLoginButton = ({
  onClick,
  disabled,
  smartLogin
}) => /*#__PURE__*/_jsx(View, {
  inlineSize: "100%",
  children: /*#__PURE__*/_jsxs(AppleSignInDiv, {
    disabled: disabled,
    onClick: onClick,
    "data-test-id": "apple-sign-in",
    children: [/*#__PURE__*/_jsx(ImageWrapper, {
      disabled: disabled,
      children: /*#__PURE__*/_jsx(FoundationsImage, {
        src: Image.appleLogo
      })
    }), /*#__PURE__*/_jsx(ButtonText, {
      children: smartLogin ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "login.form.apple"
      }) : /*#__PURE__*/_jsx(TruncateString, {
        reverse: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.form.apple"
        })
      })
    })]
  })
});
export default AppleLoginButton;